import { render, staticRenderFns } from "./backgroundSet.vue?vue&type=template&id=57345262&scoped=true"
import script from "./backgroundSet.vue?vue&type=script&lang=js"
export * from "./backgroundSet.vue?vue&type=script&lang=js"
import style0 from "./backgroundSet.vue?vue&type=style&index=0&id=57345262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57345262",
  null
  
)

export default component.exports